var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./noAccess.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?{\"id\":\"data-v-7aade7a6\"}!../../vue-loader/lib/selector?type=template&index=0!./noAccess.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ci-components/components/noAccess.vue
// module id = 243
// module chunks = 4